'use strict';

const React = require('react');
const PropTypes = require('prop-types');


class DragAndDrop extends React.Component {
    state = {
        drag: false
    }

    dropRef = React.createRef()

    handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ drag: true });
        }
    }

    handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({ drag: false });
        }
    }

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ drag: false });
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.props.handleDrop(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    }

    componentDidMount() {
        let div = this.dropRef.current;
        if (!div) return;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
        this.dragCounter = 0;
    }

    componentWillUnmount() {
        let div = this.dropRef.current;
        if (!div) return;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    }

    render() {
        return (
            <div
                ref={this.dropRef}
                style={{ ...this.props.useFlex && { display: 'flex', width: '100%' }, ...this.props.style }}
            >
                {
                    this.state.drag &&
                    <div
                        style={{
                            border: 'dashed grey 3px',
                            backgroundColor: 'rgba(255,255,255,.8)',
                            position: 'absolute',
                            top: this.props.marginTop || 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 9999
                        }}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: 0,
                                left: 0,
                                textAlign: 'center',
                                color: 'grey',
                                fontSize: this.props.small ? 14 : 36
                            }}
                        >
                            <div>{this.props.title ? this.props.title : 'Drop files to share them to the conference'}</div>
                        </div>
                    </div>
                }
                {this.props.children}
            </div >
        )
    }
}

DragAndDrop.propTypes = {
    handleDrop: PropTypes.func.isRequired,
    children: PropTypes.node,
    title: PropTypes.string,
    useFlex: PropTypes.bool,
    small: PropTypes.bool,
    marginTop: PropTypes.string,
    style: PropTypes.object
};


module.exports = DragAndDrop;
